export default [
    {
      name:"adminApplicationDetail",  path:'/admin/application/:id/:type/detail/:total', props: (route) => ({ id: Number(route.params.id),type:  Number(route.params.type),total:  Number(route.params.total)}), component: () => import('@/views/admin/application/applicationDetail')
    },
    {
        path:'/admin/application/:formType', props: (route) => ({ formType: Number(route.params.formType)}), component: () => import('@/views/admin/application')
    },
    {
        path:'/admin/interviewList/:formType', props: (route) => ({ formType: Number(route.params.formType)}), component: () => import('@/views/admin/application/interviewList')
    },
    {
        path:'/admin/dashboard', component: () => import('@/views/admin/dashboard')
    },
    {
        path:'/admin/application', component: () => import('@/views/admin/application')
    },
    {
        path:'/admin/application/:id/:type/edit',props: (route) => ({
            id:  Number(route.params.id) ,type:  Number(route.params.type)
        }), component: () => import('@/views/admin/application/editApplication')
    },
    {
        path:'/admin/bathChangeStatus/:applicationFormIds/:formType', props: (route) => ({ applicationFormIds:JSON.parse(route.params.applicationFormIds),formType: Number(route.params.formType)}),component: () => import('@/views/admin/application/bathChangeStatus')
    },
    {
        path:'/admin/providedOffer/:formType',props: (route) => ({ formType: Number(route.params.formType)}), component: () => import('@/views/admin/application/providedOffer')
    },
    {
        path:'/admin/templateManage/:formType', props: (route) => ({ formType: Number(route.params.formType)}), component: () => import('@/views/admin/application/templateManage')
    },
    {
       name:'addTemplateManage' , path:'/admin/templateManage/add/:formType', props: (route) => ({ formType: Number(route.params.formType)}), component: () => import('@/views/admin/application/addTemplate')
    },
    {
        path:'/admin/templateManage/:id/edit', props: (route) => ({ id: Number(route.params.id)}), component: () => import('@/views/admin/application/editTemplate')
    },
    {
        path:'/admin/templateManage/:id/sendTemplate/:formType', props: (route) => ({ id: Number(route.params.id),formType: Number(route.params.formType)}), component: () => import('@/views/admin/application/sendTemplate')
    },
   
    {
        path:'/admin/userActivityLogs', component: () => import('@/views/admin/userActivityLogs')
    },
    {
        path:'/admin/emailLog', component: () => import('@/views/admin/emailLog')
    },
    {
        path:'/admin/emailSetup', component: () => import('@/views/admin/emailSetup')
    },
    {
        path:'/admin/quickLink', component: () => import('@/views/admin/quickLink')
    },
    {
        path:'/admin/userAccountSetting', component: () => import('@/views/admin/userAccountSetting')
    },
    {
        path:'/admin/userAccountSetting/:id/edit',props: (route) => ({ id: Number(route.params.id)}), component: () => import('@/views/admin/userAccountSetting/edit')
    },
    {
        path:'/admin/eventStatusManage', component: () => import('@/views/admin/eventStatusManage')
    },
    {
        path:'/admin/eventStatusManage/:id/edit',props: (route) => ({ id: Number(route.params.id)}), component: () => import('@/views/admin/eventStatusManage/edit')
    },
    {
        path:'/admin/eventStatusManage/add', component: () => import('@/views/admin/eventStatusManage/add')
    },
    {
        path:'/admin/requestFromApplicant', component: () => import('@/views/admin/requestFromApplicant')
    },
    {
        path:'/admin/quickLink/add', component: () => import('@/views/admin/quickLink/add')
    },
    {
        path:'/admin/quickLink/:id/edit', props: (route) => ({ id: Number(route.params.id)}), component: () => import('@/views/admin/quickLink/edit')
    },
    {
        path:'/admin/setting', component: () => import('@/views/admin/setting')
    },
    {
        path:'/admin/templateDetail/:id',props: (route) => ({ id: Number(route.params.id)}), component: () => import('@/views/admin/application/templateDetail')
    },
]